import CitiesAPI  from "@/services/api/api-cities"
import CityDTO from "@/DTO/CityDTO"
export default {
  namespaced: true,

  state: () => ({
    items: null
  }),

  getters: {
    items: state => state.items,
  },

  mutations: {
    set(state, items) {
      state.items = items
    }
  },

  actions: {
    async list({state, commit}, params) {
      try {
        if(params && params.cache && state.items) return state.items
        let res = await CitiesAPI.listCRM()
        commit('set', res)
        return res
      } catch (error) {
        console.log(error)
        return Promise.reject(error)
      }
    },
  }
}